import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Gift, Copy, Check, MessageCircle, Trophy } from "lucide-react";
import { toast } from "sonner";

export function ReferralInvite() {
  const [ref, setRef] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/me/referral").then(({ data }) => setRef(data)).catch(() => {}); }, []);
  if (!ref) return null;
  const link = `${window.location.origin}/api/invite/${ref.code}`;
  const message = `Come test your football brain on GAFFER ⚽ — predict every scoreline and climb the worldwide table. Join me: ${link}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Invite link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.info(link);
    }
  };
  const whatsapp = () => window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");

  return (
    <div className="border-2 border-[hsl(var(--pitch-green))]/50 bg-[hsl(var(--pitch-green))]/5 p-4 mt-2" data-testid="referral-invite">
      <div className="flex items-center gap-2 mb-1">
        <Gift size={16} className="text-[hsl(var(--pitch-green))]" />
        <p className="font-display text-lg uppercase">Invite a mate — bring the banter</p>
      </div>
      <p className="text-xs text-muted-foreground mb-3">
        GAFFER is free for everyone right now. The more mates you bring in, the better the tables, rivalries and banter. Share your link:
      </p>

      {/* Reward nudge: mates brought in */}
      <div className="flex items-center gap-3 mb-3" data-testid="referral-stats">
        <div className="flex items-center gap-2 border-2 border-[hsl(var(--pitch-green))]/40 px-3 py-2">
          <Trophy size={18} className={ref.rewarded > 0 ? "text-[hsl(var(--stadium-yellow))]" : "text-muted-foreground"} />
          <div className="leading-tight">
            <div className="font-display text-2xl">{ref.rewarded}</div>
            <div className="overline text-muted-foreground text-[10px]">Mates joined</div>
          </div>
        </div>
        {ref.pending > 0 && (
          <div className="text-xs text-muted-foreground">
            <span className="font-bold text-foreground">{ref.pending}</span> invited — yet to make their first prediction
          </div>
        )}
        {ref.rewarded > 0 && (
          <div className="text-xs text-[hsl(var(--pitch-green))] font-semibold">
            🎉 Nice — your crew is growing!
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        <input readOnly value={link} data-testid="referral-link"
          className="flex-1 bg-secondary border border-border px-2 py-1.5 text-xs font-data truncate" />
        <button onClick={copy} data-testid="referral-copy-btn"
          className="inline-flex items-center gap-1 px-3 py-1.5 border border-border text-xs uppercase tracking-wider hover:border-primary/60 transition-colors">
          {copied ? <Check size={13} className="text-[hsl(var(--pitch-green))]" /> : <Copy size={13} />} Copy
        </button>
        <button onClick={whatsapp} data-testid="referral-whatsapp-btn"
          className="inline-flex items-center gap-1 px-3 py-1.5 bg-[hsl(145_63%_42%)] text-white text-xs uppercase tracking-wider hover:brightness-110 transition-all">
          <MessageCircle size={13} /> Share
        </button>
      </div>
    </div>
  );
}

